import { accessRouteChain } from './access-route-chain.js';
/** Every permission a route needs to open: its own `required` and its ancestors'. */
export function routeRequirements(route) {
    return [...new Set(accessRouteChain(route).flatMap((entry) => entry.required ?? []))];
}
//# sourceMappingURL=route-requirements.js.map